import MemberVacancyCard from './MemberVacancyCard.component';

export default MemberVacancyCard;
